/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
import { MoveDownRightIcon, MoveUpRightIcon } from "lucide-react";
import { formatDurationToHrsAndMins } from "../../utils/helper";

type ConversationMetricsProps = {
  conversationCount: number;
  growthPercentage: number;
  totalDuration: number;
  detailedConversationCount: number;
  salespersonInvolvement: number;
  customerInvolvement: number;
  auditScore: number;
  auditScoreCount: number;
  isFilterApplied: boolean;
}

const ConversationMetricsCard = ({
  conversationCount,
  growthPercentage,
  totalDuration,
  detailedConversationCount,
  salespersonInvolvement,
  customerInvolvement,
  auditScore,
  auditScoreCount,
  isFilterApplied
}: ConversationMetricsProps) => {
  const duration = formatDurationToHrsAndMins(totalDuration)

  const growthDetails = () => {
    return (
      <span className="text-xs flex items-center gap-2">
        {((growthPercentage || 0) > 0) ? (
          <span className="flex gap-0.5 text-positive-green">
            <MoveUpRightIcon className="w-4 h-4" />
            <span>{Math.abs(growthPercentage || 0).toFixed(1)}%</span>
          </span>
        ) : ((growthPercentage || 0) < 0) ? (
          <span className="flex gap-0.5 text-negative-red">
            <MoveDownRightIcon className="w-4 h-4 " />
            <span>{Math.abs(growthPercentage || 0).toFixed(1)}%</span>
          </span>
        ) : (
          <span className="flex gap-0.5">
            <span className="font-bold">~</span>
            <span>{Math.abs(growthPercentage || 0).toFixed(1)}%</span>
          </span>
        )}
        <span className="text-[#8F8F8F]">Since last week</span>
      </span>
    )
  };

  // <span className="text-xs font-normal mx-1">|</span>
  return (
    <div className='rounded-lg bg-white p-2 flex flex-col text-sm w-full min-w-[300px] max-w-full'>
      <div className="flex flex-col gap-1 bg-[#F6F6F6] rounded p-1.5">
        <div className="flex items-center justify-between">
          <span className="font-bold text-2xl">{conversationCount || 0} <span className="text-xs font-normal">Conversations</span></span>
          {duration ? (
            <span className="text-xs font-normal bg-positive-green bg-opacity-20 rounded-lg px-2 py-1 text-positive-green">
              {duration}
            </span>
          ) : []}
        </div>
        {!isFilterApplied ? (
          <div className="flex">
            {growthDetails()}
          </div>
        ) : (
          <div className="flex h-4" />
        )}
      </div>
      <div className="my-3.5 border-t border-[#EDEDED] w-full"/>
      <div className="flex justify-between">
        <div className="flex flex-col gap-0.5">
          <span className="font-bold text-base">{Math.round(Number(detailedConversationCount)) || '~'}%</span>
          <span className="text-xs text-[#8F8F8F]">Detailed</span>
        </div>
        <div className="border-r border-[#EDEDED] mx-2.5"/>
        <div className="flex flex-col gap-0.5">
          <span className="font-bold text-base">
            {salespersonInvolvement > 0 && customerInvolvement > 0 ? (
              <>
                {Number(salespersonInvolvement)?.toFixed(0) || 0}:
                {Number(customerInvolvement)?.toFixed(0) || 0}
              </>
            ) : '0:0'}
          </span>
          <span className="text-xs text-[#8F8F8F]">Talk-to-listen Ratio</span>
        </div>
        <div className="border-r border-[#EDEDED] mx-2.5"/>
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-0.5">
            <span className="font-bold text-base">
              {auditScore && !Number.isNaN(Number(auditScore)) ? `${Math.round(Number(auditScore))}%` : '-'}
            </span>
            {auditScoreCount && (
              <span className='text-xxs text-[#8f8f8f]'>
                ({auditScoreCount} Audited)
              </span>
            )}
          </div>
          <span className="text-xs text-[#8F8F8F]">Quality Score</span>
        </div>
      </div>
    </div>
  )
}

export default ConversationMetricsCard